import { render, staticRenderFns } from "./MasterIuranRekeningPusat.vue?vue&type=template&id=b6657320"
import script from "./MasterIuranRekeningPusat.vue?vue&type=script&lang=js"
export * from "./MasterIuranRekeningPusat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports